import getMaxFavoriteSuggestionCounts from './getMaxFavoriteSuggestionCounts';
import { isCategoryInFavorites } from 'owa-favorites';
import { getCategorySuggestions, getMasterCategoryList } from 'owa-categories';
/**
 * Get the favorite category suggestions based on the find text that user types
 * @param findText the find text in the favorite picker search box
 * @return an array of favorite category suggestions
 */
export default function getFavoriteCategorySuggestions(findText) {
    var categorySuggestions = getCategorySuggestions(findText, getMasterCategoryList());
    var categoryFavoriteSuggestions = [];
    for (var _i = 0, _a = categorySuggestions.suggestions; _i < _a.length; _i++) {
        var categorySuggestion = _a[_i];
        if (!isCategoryInFavorites(categorySuggestion.Id)) {
            categoryFavoriteSuggestions.push({
                data: categorySuggestion.Name,
                id: categorySuggestion.Id,
                type: 3 /* Category */,
                relevance: 0 /* Relevance scores will be supplied by providers in the future */,
            });
        }
    }
    var maxCategorySuggestions = getMaxFavoriteSuggestionCounts().category;
    categoryFavoriteSuggestions.splice(maxCategorySuggestions);
    return categoryFavoriteSuggestions;
}
//# sourceMappingURL=getFavoriteCategorySuggestions.js.map